import { Button } from "@mantine/core";
import { useCallback } from "react";
import { useThemeFlags } from "src/hooks";
import { useDispatch, useSelector } from "src/redux/hooks";
import { setCheckListsModalProps } from "src/redux/slices/generatorSlice";

import { useInputProps } from "../hooks/useInputProps";
import { getCheckListProgress } from "../utils/getCheckListProgress";

interface Props {
  id: string;
  value?: {
    name: string;
    cid: string;
    selectedIndex: number | null;
  };
}

const CheckListCell = (props: Props) => {
  const { id, value } = props;
  const dispatch = useDispatch();
  const flags = useThemeFlags();
  const { areChecklistsDisabled } = useSelector(state => state.permsSlice);
  const { value: fieldValue, disabled: inputDisabled } = useInputProps(
    id,
    value,
  );
  const checkLists = useSelector(
    state => state.generatorSlice.lbentry.checklists,
  );

  const getName = useCallback(() => {
    if (!fieldValue) return "Check List";
    let name = fieldValue.name ?? "";
    const checkList = checkLists.find(el => el.cid === fieldValue.cid);
    if (
      fieldValue.selectedIndex !== null &&
      fieldValue.selectedIndex !== undefined
    ) {
      name += `/${
        checkList?.data.list[fieldValue.selectedIndex].name
      } (${getCheckListProgress(
        (checkList?.data.list[fieldValue.selectedIndex] as any).items,
      )})`;
    } else {
      name += ` (${getCheckListProgress(checkList?.data.list)})`;
    }
    return name;
  }, [checkLists, fieldValue]);
  const handleClick = useCallback(() => {
    if (areChecklistsDisabled) return;
    dispatch(
      setCheckListsModalProps({
        opened: true,
        id,
        cid: fieldValue?.cid,
        selectedIndex: fieldValue?.selectedIndex ?? null,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps kept as they were; changing them changes when this runs
  }, [dispatch, fieldValue?.cid, id]);

  if (flags.disableChecklists) return null;

  return (
    <>
      <Button
        w="100%"
        variant="outline"
        onClick={handleClick}
        disabled={inputDisabled}
        style={{
          opacity: areChecklistsDisabled ? 0.5 : 1,
          cursor: areChecklistsDisabled ? "not-allowed" : "pointer",
        }}>
        {getName()}
      </Button>
    </>
  );
};

export default CheckListCell;
